import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { SsgTabsetComponent } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabset/tabset.component";
import { ITab, TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { EntityListAction, FiscalYear, form_control, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { Datatransfer, VoucherKindInfo } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { SystemKind } from "projects/sepidz-web-framework/src/lib/models/enums";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { AccountService, GridFilter, HttpCommonService, ShowToastrService } from "projects/sepidz-web-framework/src/lib/services";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { SimpleModalService } from "projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { InvVoucherFormComponent } from "src/app/backoffice/inv/invvoucher/invvoucher-form/invvoucher-form.component";
import { SellVoucherFormComponent } from "src/app/backoffice/sell/sell-voucher/sell-voucher-form/sell-voucher-form.component";
import { TrsVoucherFormComponent } from "src/app/backoffice/trs/trs-voucher/trs-voucher-form/trs-voucher-form.component";
import { TrsVoucherModalListComponent } from "src/app/backoffice/trs/trs-voucher/trs-voucher-modal-list/trs-voucher-modal-list.component";
import { ReviewFilterItem } from "src/app/review/models/review-filter-item";
import { GirdReviewComponent } from "src/app/review/review-card/grid-review/grid-review.component";
import { ReviewService } from "src/app/review/review.service";
import { InvVoucherModalListComponent } from "../../../inv/invvoucher/inv-voucher-modal-list/inv-voucher-modal-list.component";
import { AccVoucherFormComponent } from "../../accvoucher/accvoucher-form/accvoucher-form.component";

@Component({
  selector: "account-review",
  templateUrl: "./account-review.component.html",
  styleUrls: ["./account-review.component.scss"],
  providers: [ReviewService],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class AccountReviewComponent implements OnInit, OnDestroy {
  actions: EntityListAction[];
  unSortableFilterable: string[] = [];
  formGroup: UntypedFormGroup;
  protected ngUnsubscribe = new Subject<void>();
  GetGroupLedgerColumns: form_control[];
  GetGeneralLedgerColumns: form_control[];
  GetSubLedgerColumns: form_control[];
  GetDetailLedger1Columns: form_control[];
  GetDetailLedger2Columns: form_control[];
  GetDetailLedger3Columns: form_control[];
  GetDetailLedger4Columns: form_control[];
  GetDetailLedger5Columns: form_control[];
  GetDetailLedger6Columns: form_control[];
  GetDetailLedger7Columns: form_control[];
  GetDetailLedgerColumns: form_control[];
  GetVoucherDetailColumns: form_control[];
  GetAcoountAnalysticColumns: form_control[];
  selected: string = "";
  AccVoucherKindIds: number[] = [];
  AccStatusKindIds: number[] = [];
  SystemKindIds: number[] = [];
  BranchIds: number[] = [];
  DetailLedgerKindIds: number[] = [];
  isloaded: boolean = false;
  permisionList: NameValue[] = [];
  public activeTabTitle: string;
  @ViewChild(GirdReviewComponent) public sepidzgrid: GirdReviewComponent;
  @ViewChild(SsgTabsetComponent) public ssgTabset: SsgTabsetComponent;

  constructor(
    private service: ReviewService,
    private fb: UntypedFormBuilder,
    private missetup: MisSetupService,
    private tabsservice: TabularService,
    protected translateText: TranslateService,
    private sts: ShowToastrService,
    private accountService: AccountService,
    protected dialogService: SimpleModalService,
    private httpCommonService: HttpCommonService
  ) {
    this.onDoubleClick = this.onDoubleClick.bind(this);
    this.onActionClick = this.onActionClick.bind(this);
  }
  get _GetVoucherDetailColumns() {
    const filter = this.service.filterSubject.getValue();
    if (filter) {
      let ShowBeforeRemain: boolean = filter.items.some((r) => r.key === "ShowBeforeRemain");
      let RunningTotal: boolean = filter.items.some((r) => r.key === "ShowRunningTotal");
      this.GetVoucherDetailColumns.find((x) => x.name === "RunningTotal").listVisible = RunningTotal;
      this.GetVoucherDetailColumns.find((x) => x.name === "BeforRemainDebit").listVisible = ShowBeforeRemain;
      this.GetVoucherDetailColumns.find((x) => x.name === "BeforRemainCredit").listVisible = ShowBeforeRemain;
      this.sepidzgrid.onlyDefaultSortKey = RunningTotal;
    }
    return this.GetVoucherDetailColumns;
  }
  translate = function _translate(str: string): string {
    return this.translateText.instant(str);
  };
  _detailLedgerLevel: number;
  get detailLedgerLevel(): number {
    if (!this._detailLedgerLevel) this._detailLedgerLevel = this.missetup.getnumber("ACC", "DLLEVEL");
    return this._detailLedgerLevel;
  }

  ngOnInit(): void {
    this.setactions();
    let level = this.detailLedgerLevel;
    // this.service.startDate = new Date();
    // this.service.endDate = new Date();

    let currentFiscalYear = this.accountService.authService.currentFiscalYear;
    if (currentFiscalYear) {
      this.service.startDate.setDate(this.service.startDate.getDate() - 30);
      this.service.startDate$.next(this.service.startDate);
      if (currentFiscalYear && currentFiscalYear.StartDate) {
        let fystartDate = new Date(currentFiscalYear.StartDate);
        if (fystartDate.setHours(0, 0, 0, 0) > this.service.startDate.setHours(0, 0, 0, 0))
          this.service.startDate = this.accountService.authService.currentFiscalYear.StartDate;
        else if (fystartDate.setHours(0, 0, 0, 0) < this.service.startDate.setHours(0, 0, 0, 0)) {
          this.service.startDate = currentFiscalYear.StartDate;
          this.service.endDate = currentFiscalYear.EndDate;
          this.service.startDate$.next(currentFiscalYear.StartDate);
          this.service.endDate$.next(currentFiscalYear.EndDate);
        }
      }
    } else
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x: FiscalYear) => {
        if (x && x.StartDate) {
          this.service.startDate.setDate(this.service.startDate.getDate() - 30);
          let fystartDate = new Date(x.StartDate);
          if (fystartDate.setHours(0, 0, 0, 0) > this.service.startDate.setHours(0, 0, 0, 0)) this.service.startDate = x.StartDate;
          else if (fystartDate.setHours(0, 0, 0, 0) < this.service.startDate.setHours(0, 0, 0, 0)) {
            this.service.startDate = x.StartDate;
            this.service.endDate = x.EndDate;
            this.service.startDate$.next(x.StartDate);
            this.service.endDate$.next(x.EndDate);
          }
        }
      });
    this.BranchIds.push(this.accountService.authService.currentBranchId);
    this.service.addFilter(this.accountService.authService.currentBranch.Title, [
      <ReviewFilterItem>{
        key: "BranchIds",
        value: this.accountService.authService.currentBranchId,
        title: this.accountService.authService.currentBranch.Title,
        persianKey: this.accountService.authService.currentBranch.Title,
      },
    ]);
    this.formGroup = this.fb.group({
      AccVoucherKindIds: this.AccVoucherKindIds,
      AccStatusKindIds: this.AccStatusKindIds,
      SystemKindIds: this.SystemKindIds,
      BranchIds: this.BranchIds,
      DetailLedgerKindIds: this.DetailLedgerKindIds,
      ShowBeforeRemain: false,
      ShowRunningTotal: false,
      NotShowWithRemain: false,
      SlaveNo: undefined,
      StartNumber: undefined,
      EndNumber: undefined,
    });
    let ShowBeforeRemain: boolean = false;
    this.service.filterSubject.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
      if (x) {
        ShowBeforeRemain = x.items.some((r) => r.key === "ShowBeforeRemain");
        let RunningTotal: boolean = x.items.some((r) => r.key === "ShowRunningTotal");
        this.populateGridColumns(ShowBeforeRemain);
        if (this.GetVoucherDetailColumns && this.GetVoucherDetailColumns.length > 0) {
          this.GetVoucherDetailColumns.find((x) => x.name === "RunningTotal").listVisible = RunningTotal;
          this.GetVoucherDetailColumns.find((x) => x.name === "BeforRemainDebit").listVisible = ShowBeforeRemain;
          this.GetVoucherDetailColumns.find((x) => x.name === "BeforRemainCredit").listVisible = ShowBeforeRemain;
        }
      }
    });
    this.populateGridColumns(ShowBeforeRemain);
    this.setColumns();
  }
  setColumns() {
    this.httpCommonService
      .get("AccountReview/GetAccountReviewInfo")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          if (data) {
            this.GetVoucherDetailColumns = data as form_control[];
            this.GetVoucherDetailColumns.forEach((x) => {
              if (x.listVisible === null) x.listVisible = undefined;
            });
            this.GetVoucherDetailColumns = this.GetVoucherDetailColumns.sort((a, b) => a.order - b.order);
            this.setColumnVisiblty();
          }
        },
        (error) => console.log(error)
      );
  }
  setColumnVisiblty() {
    this.GetVoucherDetailColumns.forEach((x) => {
      if (x.name === "DetailLedger1Code" || x.name === "DetailLedger1Title") {
        x.listVisible = this.detailLedgerLevel >= 1;
      }
      if (x.name === "DetailLedger2Code" || x.name === "DetailLedger2Title") {
        x.listVisible = this.detailLedgerLevel >= 2;
      }
      if (x.name === "DetailLedger3Code" || x.name === "DetailLedger3Title") {
        x.listVisible = this.detailLedgerLevel >= 3;
      }
      if (x.name === "DetailLedger4Code" || x.name === "DetailLedger4Title") {
        x.listVisible = this.detailLedgerLevel >= 4;
      }
      if (x.name === "DetailLedger5Code" || x.name === "DetailLedger5Title") {
        x.listVisible = this.detailLedgerLevel >= 5;
      }
      if (x.name === "DetailLedger6Code" || x.name === "DetailLedger6Title") {
        x.listVisible = this.detailLedgerLevel >= 6;
      }
      if (x.name === "DetailLedger7Code" || x.name === "DetailLedger7Title") {
        x.listVisible = this.detailLedgerLevel >= 7;
      }
      if (x.name === "DetailLedger1Code" || x.name === "DetailLedger1Title") {
        x.listVisible = this.detailLedgerLevel >= 2;
      }
    });
  }
  populateGridColumns(ShowBeforeRemain: boolean): any {
    this.GetGroupLedgerColumns = [
      {
        name: "Id",
        modelName: "Id",
        listVisible: false,
        label: "سریال",
        order: 0,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "GroupLedgerCode",
        modelName: "GroupLedgerCode",
        listVisible: true,
        label: "کد گروه",
        order: 1,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "GroupLedgerTitle",
        modelName: "GroupLedgerTitle",
        listVisible: true,
        label: "عنوان گروه",
        order: 2,
        textType: "text",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Debit",
        modelName: "Debit",
        listVisible: true,
        label: "بدهکار",
        order: 5,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Credit",
        modelName: "Credit",
        listVisible: true,
        label: "بستانکار",
        order: 6,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "RemainDebit",
        modelName: "RemainDebit",
        listVisible: true,
        label: "مانده بدهکار",
        order: 7,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "RemainCredit",
        modelName: "RemainCredit",
        listVisible: true,
        label: "مانده بستانکار",
        order: 8,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
    ];
    if (ShowBeforeRemain) {
      this.GetGroupLedgerColumns.push({
        name: "BeforRemainDebit",
        modelName: "BeforRemainDebit",
        listVisible: true,
        label: "بدهکار ابتدای دوره",
        order: 3,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetGroupLedgerColumns.push({
        name: "BeforRemainCredit",
        modelName: "BeforRemainCredit",
        listVisible: true,
        label: "بستانکار ابتدای دوره",
        order: 4,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetGroupLedgerColumns = this.GetGroupLedgerColumns.sort((a, b) => a.order - b.order);
    }
    this.GetGeneralLedgerColumns = [
      {
        name: "Id",
        modelName: "Id",
        listVisible: false,
        label: "سریال",
        order: 0,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "GeneralLedgerCode",
        modelName: "GeneralLedgerCode",
        listVisible: true,
        label: "کد کل",
        order: 1,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "GeneralLedgerTitle",
        modelName: "GeneralLedgerTitle",
        listVisible: true,
        label: "عنوان کل",
        order: 2,
        textType: "text",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Debit",
        modelName: "Debit",
        listVisible: true,
        label: "بدهکار",
        order: 5,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Credit",
        modelName: "Credit",
        listVisible: true,
        label: "بستانکار",
        order: 6,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "RemainDebit",
        modelName: "RemainDebit",
        listVisible: true,
        label: "مانده بدهکار",
        order: 7,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "RemainCredit",
        modelName: "RemainCredit",
        listVisible: true,
        label: "مانده بستانکار",
        order: 8,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
    ];
    if (ShowBeforeRemain) {
      this.GetGeneralLedgerColumns.push({
        name: "BeforRemainDebit",
        modelName: "BeforRemainDebit",
        listVisible: true,
        label: "بدهکار ابتدای دوره",
        order: 3,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetGeneralLedgerColumns.push({
        name: "BeforRemainCredit",
        modelName: "BeforRemainCredit",
        listVisible: true,
        label: "بستانکار ابتدای دوره",
        order: 4,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetGeneralLedgerColumns = this.GetGeneralLedgerColumns.sort((a, b) => a.order - b.order);
    }
    this.GetSubLedgerColumns = [
      {
        name: "Id",
        modelName: "Id",
        listVisible: false,
        label: "سریال",
        order: 0,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "SubLedgerCode",
        modelName: "SubLedgerCode",
        listVisible: true,
        label: "کد معین",
        order: 1,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "SubLedgerTitle",
        modelName: "SubLedgerTitle",
        listVisible: true,
        label: "عنوان معین",
        order: 2,
        textType: "text",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Debit",
        modelName: "Debit",
        listVisible: true,
        label: "بدهکار",
        order: 5,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Credit",
        modelName: "Credit",
        listVisible: true,
        label: "بستانکار",
        order: 6,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "RemainDebit",
        modelName: "RemainDebit",
        listVisible: true,
        label: "مانده بدهکار",
        order: 7,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "RemainCredit",
        modelName: "RemainCredit",
        listVisible: true,
        label: "مانده بستانکار",
        order: 8,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
    ];
    if (ShowBeforeRemain) {
      this.GetSubLedgerColumns.push({
        name: "BeforRemainDebit",
        modelName: "BeforRemainDebit",
        listVisible: true,
        label: "بدهکار ابتدای دوره",
        order: 3,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetSubLedgerColumns.push({
        name: "BeforRemainCredit",
        modelName: "BeforRemainCredit",
        listVisible: true,
        label: "بستانکار ابتدای دوره",
        order: 4,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetSubLedgerColumns = this.GetSubLedgerColumns.sort((a, b) => a.order - b.order);
    }
    this.GetDetailLedger1Columns = [
      {
        name: "Id",
        modelName: "Id",
        listVisible: false,
        label: "سریال",
        order: 0,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "DetailLedgerCode",
        modelName: "DetailLedgerCode",
        listVisible: true,
        label: "کد حساب تفصیلی",
        order: 1,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "DetailLedgerTitle",
        modelName: "DetailLedgerTitle",
        listVisible: true,
        label: "عنوان حساب تفصیلی",
        order: 2,
        textType: "text",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Debit",
        modelName: "Debit",
        listVisible: true,
        label: "بدهکار",
        order: 5,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Credit",
        modelName: "Credit",
        listVisible: true,
        label: "بستانکار",
        order: 6,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "RemainDebit",
        modelName: "RemainDebit",
        listVisible: true,
        label: "مانده بدهکار",
        order: 7,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "RemainCredit",
        modelName: "RemainCredit",
        listVisible: true,
        label: "مانده بستانکار",
        order: 8,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
    ];
    if (ShowBeforeRemain) {
      this.GetDetailLedger1Columns.push({
        name: "BeforRemainDebit",
        modelName: "BeforRemainDebit",
        listVisible: true,
        label: "بدهکار ابتدای دوره",
        order: 3,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetDetailLedger1Columns.push({
        name: "BeforRemainCredit",
        modelName: "BeforRemainCredit",
        listVisible: true,
        label: "بستانکار ابتدای دوره",
        order: 4,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetDetailLedger1Columns = this.GetDetailLedger1Columns.sort((a, b) => a.order - b.order);
    }
    this.GetDetailLedger2Columns = [
      {
        name: "Id",
        modelName: "Id",
        listVisible: false,
        label: "سریال",
        order: 0,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "DetailLedger2Code",
        modelName: "DetailLedger2Code",
        listVisible: true,
        label: "کد حساب تفصیلی",
        order: 1,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "DetailLedger2Title",
        modelName: "DetailLedger2Title",
        listVisible: true,
        label: "عنوان حساب تفصیلی",
        order: 2,
        textType: "text",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Debit",
        modelName: "Debit",
        listVisible: true,
        label: "بدهکار",
        order: 5,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Credit",
        modelName: "Credit",
        listVisible: true,
        label: "بستانکار",
        order: 6,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "RemainDebit",
        modelName: "RemainDebit",
        listVisible: true,
        label: "مانده بدهکار",
        order: 7,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "RemainCredit",
        modelName: "RemainCredit",
        listVisible: true,
        label: "مانده بستانکار",
        order: 8,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
    ];
    if (ShowBeforeRemain) {
      this.GetDetailLedger2Columns.push({
        name: "BeforRemainDebit",
        modelName: "BeforRemainDebit",
        listVisible: true,
        label: "بدهکار ابتدای دوره",
        order: 3,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetDetailLedger2Columns.push({
        name: "BeforRemainCredit",
        modelName: "BeforRemainCredit",
        listVisible: true,
        label: "بستانکار ابتدای دوره",
        order: 4,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetDetailLedger2Columns = this.GetDetailLedger2Columns.sort((a, b) => a.order - b.order);
    }
    this.GetDetailLedger3Columns = [
      {
        name: "Id",
        modelName: "Id",
        listVisible: false,
        label: "سریال",
        order: 0,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "DetailLedger3Code",
        modelName: "DetailLedger3Code",
        listVisible: true,
        label: "کد حساب تفصیلی",
        order: 1,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "DetailLedger3Title",
        modelName: "DetailLedger3Title",
        listVisible: true,
        label: "عنوان حساب تفصیلی",
        order: 2,
        textType: "text",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Debit",
        modelName: "Debit",
        listVisible: true,
        label: "بدهکار",
        order: 5,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Credit",
        modelName: "Credit",
        listVisible: true,
        label: "بستانکار",
        order: 6,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "RemainDebit",
        modelName: "RemainDebit",
        listVisible: true,
        label: "مانده بدهکار",
        order: 7,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "RemainCredit",
        modelName: "RemainCredit",
        listVisible: true,
        label: "مانده بستانکار",
        order: 8,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
    ];
    if (ShowBeforeRemain) {
      this.GetDetailLedger3Columns.push({
        name: "BeforRemainDebit",
        modelName: "BeforRemainDebit",
        listVisible: true,
        label: "بدهکار ابتدای دوره",
        order: 3,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetDetailLedger3Columns.push({
        name: "BeforRemainCredit",
        modelName: "BeforRemainCredit",
        listVisible: true,
        label: "بستانکار ابتدای دوره",
        order: 4,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetDetailLedger3Columns = this.GetDetailLedger3Columns.sort((a, b) => a.order - b.order);
    }
    this.GetDetailLedger4Columns = [
      {
        name: "Id",
        modelName: "Id",
        listVisible: false,
        label: "سریال",
        order: 0,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "DetailLedger4Code",
        modelName: "DetailLedger4Code",
        listVisible: true,
        label: "کد حساب تفصیلی",
        order: 1,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "DetailLedger4Title",
        modelName: "DetailLedger4Title",
        listVisible: true,
        label: "عنوان حساب تفصیلی",
        order: 2,
        textType: "text",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Debit",
        modelName: "Debit",
        listVisible: true,
        label: "بدهکار",
        order: 5,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Credit",
        modelName: "Credit",
        listVisible: true,
        label: "بستانکار",
        order: 6,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "RemainDebit",
        modelName: "RemainDebit",
        listVisible: true,
        label: "مانده بدهکار",
        order: 7,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "RemainCredit",
        modelName: "RemainCredit",
        listVisible: true,
        label: "مانده بستانکار",
        order: 8,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
    ];
    if (ShowBeforeRemain) {
      this.GetDetailLedger4Columns.push({
        name: "BeforRemainDebit",
        modelName: "BeforRemainDebit",
        listVisible: true,
        label: "بدهکار ابتدای دوره",
        order: 3,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetDetailLedger4Columns.push({
        name: "BeforRemainCredit",
        modelName: "BeforRemainCredit",
        listVisible: true,
        label: "بستانکار ابتدای دوره",
        order: 4,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetDetailLedger4Columns = this.GetDetailLedger4Columns.sort((a, b) => a.order - b.order);
    }
    this.GetDetailLedger5Columns = [
      {
        name: "Id",
        modelName: "Id",
        listVisible: false,
        label: "سریال",
        order: 0,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "DetailLedger5Code",
        modelName: "DetailLedger5Code",
        listVisible: true,
        label: "کد حساب تفصیلی",
        order: 1,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "DetailLedger5Title",
        modelName: "DetailLedger5Title",
        listVisible: true,
        label: "عنوان حساب تفصیلی",
        order: 2,
        textType: "text",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Debit",
        modelName: "Debit",
        listVisible: true,
        label: "بدهکار",
        order: 5,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Credit",
        modelName: "Credit",
        listVisible: true,
        label: "بستانکار",
        order: 6,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "RemainDebit",
        modelName: "RemainDebit",
        listVisible: true,
        label: "مانده بدهکار",
        order: 7,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "RemainCredit",
        modelName: "RemainCredit",
        listVisible: true,
        label: "مانده بستانکار",
        order: 8,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
    ];
    if (ShowBeforeRemain) {
      this.GetDetailLedger5Columns.push({
        name: "BeforRemainDebit",
        modelName: "BeforRemainDebit",
        listVisible: true,
        label: "بدهکار ابتدای دوره",
        order: 3,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetDetailLedger5Columns.push({
        name: "BeforRemainCredit",
        modelName: "BeforRemainCredit",
        listVisible: true,
        label: "بستانکار ابتدای دوره",
        order: 4,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetDetailLedger5Columns = this.GetDetailLedger5Columns.sort((a, b) => a.order - b.order);
    }
    this.GetDetailLedger6Columns = [
      {
        name: "Id",
        modelName: "Id",
        listVisible: false,
        label: "سریال",
        order: 0,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "DetailLedger6Code",
        modelName: "DetailLedger6Code",
        listVisible: true,
        label: "کد حساب تفصیلی",
        order: 1,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "DetailLedger6Title",
        modelName: "DetailLedger6Title",
        listVisible: true,
        label: "عنوان حساب تفصیلی",
        order: 2,
        textType: "text",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Debit",
        modelName: "Debit",
        listVisible: true,
        label: "بدهکار",
        order: 5,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Credit",
        modelName: "Credit",
        listVisible: true,
        label: "بستانکار",
        order: 6,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "RemainDebit",
        modelName: "RemainDebit",
        listVisible: true,
        label: "مانده بدهکار",
        order: 7,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "RemainCredit",
        modelName: "RemainCredit",
        listVisible: true,
        label: "مانده بستانکار",
        order: 8,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
    ];
    if (ShowBeforeRemain) {
      this.GetDetailLedger6Columns.push({
        name: "BeforRemainDebit",
        modelName: "BeforRemainDebit",
        listVisible: true,
        label: "بدهکار ابتدای دوره",
        order: 3,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetDetailLedger6Columns.push({
        name: "BeforRemainCredit",
        modelName: "BeforRemainCredit",
        listVisible: true,
        label: "بستانکار ابتدای دوره",
        order: 4,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetDetailLedger6Columns = this.GetDetailLedger6Columns.sort((a, b) => a.order - b.order);
    }
    this.GetDetailLedger7Columns = [
      {
        name: "Id",
        modelName: "Id",
        listVisible: false,
        label: "سریال",
        order: 0,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "DetailLedger7Code",
        modelName: "DetailLedger7Code",
        listVisible: true,
        label: "کد حساب تفصیلی",
        order: 1,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "DetailLedger7Title",
        modelName: "DetailLedger7Title",
        listVisible: true,
        label: "عنوان حساب تفصیلی",
        order: 2,
        textType: "text",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Debit",
        modelName: "Debit",
        listVisible: true,
        label: "بدهکار",
        order: 5,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Credit",
        modelName: "Credit",
        listVisible: true,
        label: "بستانکار",
        order: 6,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "RemainDebit",
        modelName: "RemainDebit",
        listVisible: true,
        label: "مانده بدهکار",
        order: 7,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "RemainCredit",
        modelName: "RemainCredit",
        listVisible: true,
        label: "مانده بستانکار",
        order: 8,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
    ];
    if (ShowBeforeRemain) {
      this.GetDetailLedger7Columns.push({
        name: "BeforRemainDebit",
        modelName: "BeforRemainDebit",
        listVisible: true,
        label: "بدهکار ابتدای دوره",
        order: 3,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetDetailLedger7Columns.push({
        name: "BeforRemainCredit",
        modelName: "BeforRemainCredit",
        listVisible: true,
        label: "بستانکار ابتدای دوره",
        order: 4,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetDetailLedger7Columns = this.GetDetailLedger7Columns.sort((a, b) => a.order - b.order);
    }
    this.GetDetailLedgerColumns = [
      {
        name: "Id",
        modelName: "Id",
        listVisible: false,
        label: "سریال",
        order: 0,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "DetailLedgerCode",
        modelName: "DetailLedgerCode",
        listVisible: true,
        label: "کد حساب تفصیلی",
        order: 1,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "DetailLedgerTitle",
        modelName: "DetailLedgerTitle",
        listVisible: true,
        label: "عنوان حساب تفصیلی",
        order: 2,
        textType: "text",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Debit",
        modelName: "Debit",
        listVisible: true,
        label: "بدهکار",
        order: 5,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Credit",
        modelName: "Credit",
        listVisible: true,
        label: "بستانکار",
        order: 6,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "RemainDebit",
        modelName: "RemainDebit",
        listVisible: true,
        label: "مانده بدهکار",
        order: 7,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "RemainCredit",
        modelName: "RemainCredit",
        listVisible: true,
        label: "مانده بستانکار",
        order: 8,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
    ];
    if (ShowBeforeRemain) {
      this.GetDetailLedgerColumns.push({
        name: "BeforRemainDebit",
        modelName: "BeforRemainDebit",
        listVisible: true,
        label: "بدهکار ابتدای دوره",
        order: 3,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetDetailLedgerColumns.push({
        name: "BeforRemainCredit",
        modelName: "BeforRemainCredit",
        listVisible: true,
        label: "بستانکار ابتدای دوره",
        order: 4,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetDetailLedgerColumns = this.GetDetailLedgerColumns.sort((a, b) => a.order - b.order);
    }
    this.GetAcoountAnalysticColumns = [
      {
        name: "GroupLedgerCode",
        modelName: "GroupLedgerCode",
        listVisible: true,
        label: "کد گروه حساب",
        order: 1,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "GroupLedgerTitle",
        modelName: "GroupLedgerTitle",
        listVisible: true,
        label: "عنوان گروه حساب",
        order: 2,
        textType: "text",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "GeneralLedgerCode",
        modelName: "GeneralLedgerCode",
        listVisible: true,
        label: "کد حساب کل",
        order: 3,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "GeneralLedgerTitle",
        modelName: "GeneralLedgerTitle",
        listVisible: true,
        label: "عنوان حساب کل",
        order: 4,
        textType: "text",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "SubLedgerCode",
        modelName: "SubLedgerCode",
        listVisible: true,
        label: "کد حساب معین",
        order: 5,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "SubLedgerTitle",
        modelName: "SubLedgerTitle",
        listVisible: true,
        label: "عنوان حساب معین",
        order: 6,
        textType: "text",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
    ];

    if (this.detailLedgerLevel >= 1) {
      this.GetAcoountAnalysticColumns.push({
        name: "DetailLedger1Code",
        modelName: "DetailLedger1Code",
        listVisible: true,
        label: "کد حساب تفصیلی 1",
        order: 7,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetAcoountAnalysticColumns.push({
        name: "DetailLedger1Title",
        modelName: "DetailLedger1Title",
        listVisible: true,
        label: "عنوان حساب تفصیلی 1",
        order: 8,
        textType: "text",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
    }
    if (this.detailLedgerLevel >= 2) {
      this.GetAcoountAnalysticColumns.push({
        name: "DetailLedger2Code",
        modelName: "DetailLedger2Code",
        listVisible: true,
        label: "کد حساب تفصیلی 2",
        order: 9,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetAcoountAnalysticColumns.push({
        name: "DetailLedger2Title",
        modelName: "DetailLedger2Title",
        listVisible: true,
        label: "عنوان حساب تفصیلی 2",
        order: 10,
        textType: "text",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
    }
    if (this.detailLedgerLevel >= 3) {
      this.GetAcoountAnalysticColumns.push({
        name: "DetailLedger3Code",
        modelName: "DetailLedger3Code",
        listVisible: true,
        label: "کد حساب تفصیلی 3",
        order: 11,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetAcoountAnalysticColumns.push({
        name: "DetailLedger3Title",
        modelName: "DetailLedger3Title",
        listVisible: true,
        label: "عنوان حساب تفصیلی 3",
        order: 12,
        textType: "text",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
    }
    if (this.detailLedgerLevel >= 4) {
      this.GetAcoountAnalysticColumns.push({
        name: "DetailLedger4Code",
        modelName: "DetailLedger4Code",
        listVisible: true,
        label: "کد حساب تفصیلی 4",
        order: 13,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetAcoountAnalysticColumns.push({
        name: "DetailLedger4Title",
        modelName: "DetailLedger4Title",
        listVisible: true,
        label: "عنوان حساب تفصیلی 4",
        order: 14,
        textType: "text",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
    }
    if (this.detailLedgerLevel >= 5) {
      this.GetAcoountAnalysticColumns.push({
        name: "DetailLedger5Code",
        modelName: "DetailLedger5Code",
        listVisible: true,
        label: "کد حساب تفصیلی 5",
        order: 15,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetAcoountAnalysticColumns.push({
        name: "DetailLedger5Title",
        modelName: "DetailLedger5Title",
        listVisible: true,
        label: "عنوان حساب تفصیلی 5",
        order: 16,
        textType: "text",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
    }
    if (this.detailLedgerLevel >= 6) {
      this.GetAcoountAnalysticColumns.push({
        name: "DetailLedger6Code",
        modelName: "DetailLedger6Code",
        listVisible: true,
        label: "کد حساب تفصیلی 6",
        order: 17,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetAcoountAnalysticColumns.push({
        name: "DetailLedger6Title",
        modelName: "DetailLedger6Title",
        listVisible: true,
        label: "عنوان حساب تفصیلی 6",
        order: 18,
        textType: "text",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
    }
    if (this.detailLedgerLevel >= 7) {
      this.GetAcoountAnalysticColumns.push({
        name: "DetailLedger7Code",
        modelName: "DetailLedger7Code",
        listVisible: true,
        label: "کد تفصیلی هفتم",
        order: 19,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetAcoountAnalysticColumns.push({
        name: "DetailLedger7Title",
        modelName: "DetailLedger7Title",
        listVisible: true,
        label: "عنوان تفصیلی هفتم",
        order: 20,
        textType: "text",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
    }
    this.GetAcoountAnalysticColumns.push({
      name: "Debit",
      modelName: "Debit",
      listVisible: true,
      label: "بدهکار",
      order: 25,
      textType: "number",
      withComma: true,
      isDecimal: true,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetAcoountAnalysticColumns.push({
      name: "Credit",
      modelName: "Credit",
      listVisible: true,
      label: "بستانکار",
      order: 26,
      textType: "number",
      withComma: true,
      isDecimal: true,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });

    this.GetAcoountAnalysticColumns.push({
      name: "RemainDebit",
      modelName: "RemainDebit",
      listVisible: false,
      label: "مانده بدهکار",
      order: 27,
      textType: "number",
      withComma: true,
      isDecimal: true,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetAcoountAnalysticColumns.push({
      name: "RemainCredit",
      modelName: "RemainCredit",
      listVisible: false,
      label: "مانده بستانکار",
      order: 28,
      textType: "number",
      withComma: true,
      isDecimal: true,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });

    if (ShowBeforeRemain) {
      this.GetAcoountAnalysticColumns.push({
        name: "BeforRemainDebit",
        modelName: "BeforRemainDebit",
        listVisible: true,
        label: "بدهکار ابتدای دوره",
        order: 21,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetAcoountAnalysticColumns.push({
        name: "BeforRemainCredit",
        modelName: "BeforRemainCredit",
        listVisible: true,
        label: "بستانکار ابتدای دوره",
        order: 22,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      });
      this.GetAcoountAnalysticColumns = this.GetAcoountAnalysticColumns.sort((a, b) => a.order - b.order);
    }
  }
  isActveTab(title: string) {
    return this.activeTabTitle === title;
  }
  selectTab($event) {
    this.activeTabTitle = $event.tabTitle;
  }
  detailLedgerLevelValidate(level: number, _apiName: string): boolean {
    let flag: boolean = false;

    let temp = this.permisionList.find((x) => x.Name === `${_apiName}-${level}`);
    if (!temp) flag = this.detailLedgerLevel >= level && this.accountService.userHasPermission(_apiName, Permission.samePermission);
    else flag = temp.Value as boolean;
    if (!this.permisionList.some((x) => x.Name === `${_apiName}-${level}`)) this.permisionList.push({ Name: `${_apiName}-${level}`, Value: flag });
    return flag;
  }
  onActionClick(action: EntityListAction, onRowSelected: any, onRowsSelected: any[], isAllSelected: boolean, gridFilter: GridFilter[]) {
    ///نمایش سند حسابداری
    if (action.name === "AccVoucherHeader") {
      var datatrasfer: Datatransfer = <Datatransfer>{};
      onRowSelected.Id = onRowSelected.AccVoucherHeaderId;
      datatrasfer.apiName = action.apiName;
      datatrasfer.areaName = action.areaName;
      datatrasfer.currentrow = onRowSelected;
      action.Form_Component = AccVoucherFormComponent;
      datatrasfer.apiName = "AccVoucherHeader";
      datatrasfer.areaName = "Accounting";
      datatrasfer.label = "سند حسابداری";
      this.showVoucher(datatrasfer, action);
    }

    ///سند مبنا
    if (action.name === "BaseVoucher") {
      var datatrasfer: Datatransfer = <Datatransfer>{};
      datatrasfer.apiName = action.apiName;
      datatrasfer.areaName = action.areaName;

      if (!onRowSelected || !onRowSelected.AccVoucherHeaderId || onRowSelected.SystemKindCode === SystemKind.ACC) {
        this.sts.showDialog("هیچ رکوردی انتخاب نشده است/سند مبنا وجود ندارد.", "");
        return;
      } else if (onRowSelected) {
        if (onRowSelected.SystemKindCode === SystemKind.INV) {
          action.Form_Component = InvVoucherFormComponent;
          datatrasfer.apiName = "InvVoucherHeader";
          datatrasfer.areaName = "Inventory";
          datatrasfer.label = "سند انبار";
          this.httpCommonService
            .getList(`InvVoucherHeader/GetbyAccVoucherId/${onRowSelected.AccVoucherHeaderId}`)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data: any[]) => {
                if (data) {
                  if (data.length == 1) {
                    datatrasfer.currentrow = data[0];
                    this.showVoucher(datatrasfer, action);
                  } else {
                    this.dialogService
                      .open(
                        InvVoucherModalListComponent,
                        {
                          label: datatrasfer.label,
                          dataList: data,
                        },
                        {
                          autoFocus: true,
                          closeOnClickOutside: false,
                          closeOnEscape: false,
                        }
                      )
                      .pipe(takeUntil(this.ngUnsubscribe))
                      .subscribe((model) => {
                        if (model) {
                          datatrasfer.currentrow = model;
                          this.showVoucher(datatrasfer, action);
                        }
                      });
                  }
                }
              },
              (error) => console.log(error)
            );
        }
        if (onRowSelected.SystemKindCode === SystemKind.TRS) {
          action.Form_Component = TrsVoucherFormComponent;
          onRowSelected.Id = onRowSelected.TrsVoucherHeaderId;
          datatrasfer.apiName = "TrsVoucherHeader";
          datatrasfer.areaName = "Treasury";
          datatrasfer.label = "سند خزانه";
          this.httpCommonService
            .getList(`TrsVoucherHeader/GetbyAccVoucherId/${onRowSelected.AccVoucherHeaderId}`)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data: any[]) => {
                if (data) {
                  if (data.length == 1) {
                    datatrasfer.currentrow = data[0];
                    this.showVoucher(datatrasfer, action);
                  } else {
                    this.dialogService
                      .open(
                        TrsVoucherModalListComponent,
                        {
                          label: datatrasfer.label,
                          dataList: data,
                        },
                        {
                          autoFocus: true,
                          closeOnClickOutside: false,
                          closeOnEscape: false,
                        }
                      )
                      .pipe(takeUntil(this.ngUnsubscribe))
                      .subscribe((model) => {
                        if (model) {
                          datatrasfer.currentrow = model;
                          this.showVoucher(datatrasfer, action);
                        }
                      });
                  }
                }
              },
              (error) => console.log(error)
            );
        }
        if (onRowSelected.SystemKindCode === SystemKind.SELL) {
          action.Form_Component = SellVoucherFormComponent;
          //onRowSelected.Id=onRowSelected.AccountingSubSystemsRelationships[0].SellVoucherHeaderId;
          datatrasfer.apiName = "SellVoucherHeader";
          datatrasfer.areaName = "SellCustomer";
          datatrasfer.label = "سند فروش";
        }
      }
    }
  }
  showVoucher(datatrasfer: Datatransfer, action: any) {
    const menu = <ITab>{
      title: datatrasfer.label,
      isCloseable: true,
      icon: action.iconName,
      active: true,
      responsive: true,
      componentType: action.Form_Component,
      data: [
        { provide: EntityBase, useValue: datatrasfer.currentrow },
        { provide: Datatransfer, useValue: datatrasfer },
        { provide: VoucherKindInfo, useValue: <VoucherKindInfo>{ VoucherKindId: 0 } },
      ],
    };
    this.tabsservice.open(menu);
  }
  setactions() {
    this.actions = [
      {
        name: "AccVoucherHeader",
        disabled: false,
        displayName: "نمایش سند حسابداری",
        isModal: false,
        iconName: "icon-table_view-f",
        Form_Component: AccVoucherFormComponent,
        apiName: "AccVoucherHeader",
        areaName: "Accounting",
      },
      {
        name: "BaseVoucher",
        disabled: false,
        displayName: "سند مبنا",
        iconName: "icon-folder-open-outline",
        areaName: "Accounting",
        Form_Component: AccVoucherFormComponent,
        apiName: "AccVoucherHeader",
      },
    ];
  }

  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
  }

  onDoubleClick(): boolean {
    if (this.activeTabTitle === this.translate("ClientApp.BackOffice.ACC.GroupLedger.GroupLedger"))
      this.activeTabTitle = this.translate("ClientApp.BackOffice.ACC.GeneralLedger.GeneralLedger");
    else if (this.activeTabTitle === this.translate("ClientApp.BackOffice.ACC.GeneralLedger.GeneralLedger"))
      this.activeTabTitle = this.translate("ClientApp.BackOffice.ACC.SubLedger.SubLedger");
    else if (this.activeTabTitle === this.translate("ClientApp.BackOffice.ACC.SubLedger.SubLedger") && this.detailLedgerLevel >= 1)
      this.activeTabTitle = this.translate("ClientApp.BackOffice.ACC.SubLedger.DetailLedger1");
    else if (this.activeTabTitle === this.translate("ClientApp.BackOffice.ACC.SubLedger.DetailLedger1") && this.detailLedgerLevel >= 2)
      this.activeTabTitle = this.translate("ClientApp.BackOffice.ACC.SubLedger.DetailLedger2");
    else if (this.activeTabTitle === this.translate("ClientApp.BackOffice.ACC.SubLedger.DetailLedger2") && this.detailLedgerLevel >= 3)
      this.activeTabTitle = this.translate("ClientApp.BackOffice.ACC.SubLedger.DetailLedger3");
    else if (this.activeTabTitle === this.translate("ClientApp.BackOffice.ACC.SubLedger.DetailLedger3") && this.detailLedgerLevel >= 4)
      this.activeTabTitle = this.translate("ClientApp.BackOffice.ACC.SubLedger.DetailLedger4");
    else if (this.activeTabTitle === this.translate("ClientApp.BackOffice.ACC.SubLedger.DetailLedger4") && this.detailLedgerLevel >= 5)
      this.activeTabTitle = this.translate("ClientApp.BackOffice.ACC.SubLedger.DetailLedger5");
    else if (this.activeTabTitle === this.translate("ClientApp.BackOffice.ACC.SubLedger.DetailLedger5") && this.detailLedgerLevel >= 6)
      this.activeTabTitle = this.translate("ClientApp.BackOffice.ACC.SubLedger.DetailLedger6");
    else {
      this.activeTabTitle = "گردش حساب";
      let index = 0;
      this.ssgTabset.tabs.forEach((x) => {
        if (x.tabTitle === this.activeTabTitle) {
          x.active = true;
          this.ssgTabset.selectTab(x, index);
          index++;
        }
      });
    }
    return true;
  }
  setSelectedFilter(filter: string) {
    if (this.selected === filter) this.selected = "";
    else this.selected = filter;
  }
}
